import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { tableHeadList } from "./parts";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import TkDataTable from "../../components/molecules/TkDataTable";
import { httpAPI_RET011, httpAPI_RET014 } from "./api/request";
import { GetBodyList } from "./hooks/useHooks";
import "./_style.scss";
import { SCRW070008SearchForm } from "./components/components";
import { IAPI_RET011_Request } from "../../type/apiType";

/**
 * SCRW070008 退職者状況一覧
 * @return SCRW070008 退職者状況一覧
 */
const SCRW070008 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [bodyList, setBodyList] = useState<any>([]);

  useEffect(() => {
    if (businessState?.searchForRetirement) {
      handleSearch(businessState?.searchForRetirement);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 退職届状況 リンク 押下
  const handleRetireeStatusClick = (item: any, search?: any) => {
    setBusinessState({
      ...businessState,
      common: {
        contractorNo: item.contractorNo,
        contractorName: item.contractorName,
      },
      job_32: {
        applyId: item.retireId,
        staffNo: item.staffNo
      },
      searchForRetirement: search,
    });

    if (item.transferFlg === "1") {
      navigate("/SCRW060005");
    } else {
      navigate("/SCRW060004");
    }
  };

  // 合算／請求 リンク 押下
  const handleTotalBillingClick = async (
    linkName: string,
    item: any,
    search?: any
  ) => {
    if (linkName === "請求") {
      setBusinessState({
        ...businessState,
        common: {
          ...businessState.common,
          contractorNo: item.contractorNo,
          contractorName: item.contractorName,
        },
        job_32: {
          ...businessState.job_32,
          staffNo: item.staffNo,
        },
        searchForRetirement: search,
      });

      navigate("/SCRC060129", { state: { applyId: item.retireApplyId } });
    } else {
      // 退職者申請メール参照API 呼び出し
      try {
        const res = await httpAPI_RET014({
          applyId: item.applyId,
        });

        if (res.resultCd === "I0000") {
          setState({
            ...state,
            errorMsgId: "",
          });

          setBusinessState({
            ...businessState,
            common: {
              ...businessState.common,
              contractorNo: item.contractorNo,
            },
            searchForRetirement: search,
          });
          navigate("/SCRW130003", {
            state: {
              emailId: res.emailId,
              emailAddress: res.email,
              contractorNo: item.contractorNo,
            },
          });
        } else {
          setState({
            ...state,
            errorMsgId: res.resultCd,
          });
        }
      } catch (error) {
        navigate("/error");
      }
    }
  };

  // 退職情報登録 リンク 押下
  const handleLinkClick = (item: any, search?: any) => {
    setBusinessState({
      ...businessState,
      common: {
        contractorNo: item.contractorNo,
        contractorName: item.contractorName,
      },
      job_01: {
        applyId: item.retireApplyId,
      },
      searchForRetirement: search,
    });
    navigate("/SCRW410001", { state: { applyId: item.retireApplyId } });
  };
  
  // 業務チェック
  function businessCheck(value: IAPI_RET011_Request) {
    if(
      !value?.contractorNo
      && !value?.retireStaffNo
      && !value?.domesticResidenceFlg
      && !value?.retireYears
      && !value?.paymentStatus
    ) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SVR0067E",
      });
      return false;
    }
    return true;
  }

  const handleSearch = async (value: any) => {
    // 退職者状況一覧参照API 呼び出し
    let param = { ...value };
    delete param.contractorName;
    delete param.staffName;
    try {
      if(!businessCheck(value)) return;
      const res = await httpAPI_RET011({
        ...param,
      });

      if (res.resultCd === "I0000" || res.resultCd === "TKMSG_SVR0126E") {
        setBodyList(
          GetBodyList(
            res,
            handleRetireeStatusClick,
            handleTotalBillingClick,
            handleLinkClick,
            value
          )
        );
        setState({
          ...state,
          errorMsgId: res.resultCd === "TKMSG_SVR0126E" ? res.resultCd : "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box className="SCRW070008" data-testid="SCRW070008PageForTest">
      <SCRW070008SearchForm
        onSearch={handleSearch}
        defaultValue={businessState?.searchForRetirement}
      />
      <TkDataTable headList={tableHeadList} bodyList={bodyList} pagin />
    </Box>
  );
};

export default SCRW070008;
